module.exports = __webpack_public_path__ + "static/media/icn_mainnav_dashboard_light.8cf060f1.svg";